export const getNumberOfActiveFilters = (filters) =>
  filters.tags.length +
  (filters.duration ? 1 : 0) +
  (filters.examDone !== null && filters.examDone !== undefined ? 1 : 0);
